import { AxiosInstance, AxiosResponse } from 'axios'

import { SearchRepository } from './domain/SearchRepository'

import { CommunityDocument } from '../../contracts/community'
import {
  Address,
  queryAddressCriteria,
  RelatedTreatment,
  SearchCommunityDocumentFilter,
  SearchEventParam,
  SuggestionContextResponse,
} from '../../contracts/search'
import { AxiosErrorHandler, SolarPagedResponse } from '../../foundation'
import { SearchAllResponse, SearchServiceOffersResponse } from '../../contracts/search/SearchResponse'
import { SearchAllRequest, SearchServiceOffersRequest } from '../../contracts/search/SearchRequest'

export const querySearchDocuments = async (fetcher: AxiosInstance, params: SearchCommunityDocumentFilter) => {
  return fetcher.get<SolarPagedResponse<CommunityDocument[]>>('/search/document', {
    params,
  })
}

export const querySearchEvent = async (
  fetcher: AxiosInstance,
  params: SearchEventParam,
): Promise<SolarPagedResponse<RelatedTreatment[]>> => {
  const { data } = await fetcher.get<SolarPagedResponse<RelatedTreatment[]>>('/search/event', {
    params,
  })

  return data
}

export const queryAddress = async (fetcher: AxiosInstance, params: queryAddressCriteria): Promise<Address> => {
  const result = await fetcher.get<Address>('/v2/local/search/address.json', { params })

  return result.data
}

export class SearchApiClient implements SearchRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  /**
   * [Swagger 링크](https://supernova-display-api.test.gnst.me/display/swagger-ui/index.html#/search-context-controller/getRecommend)
   */
  searchRecommendation = async (params: {
    q: string
  }): Promise<AxiosResponse<{ candies: SuggestionContextResponse[] }>> => {
    const result = await this.axios.get<AxiosResponse<{ candies: SuggestionContextResponse[] }>>('/search/v2/rcmd', {
      params,
    })

    return result.data
  }

  /**
   * [Swagger 링크](https://supernova-display-api.test.gnst.me/display/swagger-ui/index.html#/user-search-view-controller/readSearchViewAll)
   */
  searchAll = async (params: SearchAllRequest): Promise<SearchAllResponse> => {
    try {
      const { data } = await this.axios.post<SearchAllResponse>('/display/search-view/all', params)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
  /**
   * [Swagger 링크](https://supernova-display-api.test.gnst.me/display/swagger-ui/index.html#/user-search-view-controller/readServiceOffers)
   */
  searchServiceOffers = async (params: SearchServiceOffersRequest): Promise<SearchServiceOffersResponse> => {
    try {
      const { data } = await this.axios.post<SearchServiceOffersResponse>('/display/search-view/service-offers', params)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
